import { Box, Paper, TextField, useMediaQuery } from "@mui/material";
import { PaperStyles } from "../../styles/commonStyles";
import SubmitButton from "../buttons/submitButton.component";
import CustomDialog from "../muiDialogs/dialog.component";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import {
  deleteCultureStart,
  resetCreateCultureState,
  resetUpdateCultureState,
} from "../../store/features/culture/cultureSlice";
import { dialogMessages } from "./utils";
import { useForm } from "react-hook-form";
import FormActionButton from "../buttons/formActionButton.component";
import { Delete } from "@mui/icons-material";
import SuccessDialog from "../muiDialogs/successDialog.component";

const CultureForm = ({
  defaultValues = {},
  onSubmit,
  isLoading,
  mode = "create",
  success,
  error,
  accessToken,
  culture,
}) => {
  const isDesktop = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMode, setDialogMode] = useState(null);
  const [isAction, setIsAction] = useState(false);

  const isUpdateMode = mode === "update";

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({ defaultValues });

  useEffect(() => {
    reset(defaultValues);
  }, [defaultValues, reset]);

  const handleDialogClose = () => {
    setDialogOpen(false);
  };
  const handleDialogConfirm = () => {
    if (dialogMode) {
      dispatch(deleteCultureStart({ userId: culture.id, accessToken }));
      setDialogOpen(false);
    }
  };

  const handleSuccessDialogConfirm = () => {
    dispatch(resetCreateCultureState());
    dispatch(resetUpdateCultureState());
    setDialogOpen(false);
    navigate("/admin/cultureList");
  };

  useEffect(() => {
    if (success && !dialogOpen) {
      setDialogOpen(true);
    }
  }, [dialogOpen, success]);

  useEffect(() => {
    if (success && dialogMode === "delete") {
      dispatch(resetCreateCultureState());
      dispatch(resetUpdateCultureState());
      navigate("/admin/cultureList");
    }
  }, [dialogMode, success, navigate, dispatch]);

  return (
    <Box>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Paper sx={PaperStyles} elevation={0}>
          {isUpdateMode && (
            <Box width="100%" display="flex" justifyContent="end" mb={2}>
              <FormActionButton
                startIcon={<Delete />}
                color="error"
                label="Elimina"
                onClick={() => {
                  setDialogMode("delete");
                  setIsAction(true);
                  setDialogOpen(true);
                }}
              />
            </Box>
          )}
          <Box
            display="flex"
            alignItems="center"
            gap="16px"
            justifyContent="center"
            flexDirection={isDesktop ? "row" : "column"}
          >
            <TextField
              variant="filled"
              id="name"
              label="Nome tipologia"
              fullWidth
              sx={{ "& .MuiFilledInput-root": { height: "50px" } }}
              {...register("name", { required: "Campo obbligatorio" })}
              error={!!errors.name || !!error}
              helperText={errors.name?.message}
              disabled={isLoading}
            />
          </Box>
        </Paper>
        <SubmitButton
          label={!isUpdateMode ? "Salva Coltura" : "Aggiorna coltura"}
          type="submit"
          disabled={isLoading}
        />
      </form>
      {dialogMode ? (
        <CustomDialog
          open={dialogOpen}
          onClose={handleDialogClose}
          onConfirm={handleDialogConfirm}
          title={dialogMessages.culture[dialogMode || mode].title}
          description={dialogMessages.culture[dialogMode || mode].description}
          actions={isAction}
        />
      ) : (
        <SuccessDialog
          open={dialogOpen}
          onClose={handleDialogClose}
          onConfirm={handleSuccessDialogConfirm}
          title={dialogMessages.culture[dialogMode || mode].title}
          description={dialogMessages.culture[dialogMode || mode].description}
        />
      )}
    </Box>
  );
};

export default CultureForm;
